import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getModerationSettingsKey } from '../../utils/keys';
export const useUpdateModerationSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const moderationSettingsKey = getModerationSettingsKey();
    return useMutation(variables => client.moderation.updateSettings(variables), {
        onMutate: async (newModerationSettings) => {
            await queryClient.cancelQueries(moderationSettingsKey);
            const snapshot = queryClient.getQueryData(moderationSettingsKey);
            queryClient.setQueryData(moderationSettingsKey, old => {
                return {
                    ...old,
                    ...newModerationSettings,
                };
            });
            return { snapshot };
        },
        onError: (err, newNetworkSettings, context) => {
            // revert back the optimistic response
            queryClient.setQueryData(moderationSettingsKey, context.snapshot);
        },
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(moderationSettingsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateModerationSettings.js.map